<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <edit-info>
        </edit-info> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import editInfo from './todo-edit-info'
export default {
    components: {
        editInfo
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-edit-info.vue